import * as z from 'zod';

export const governanceQueryLinkerSchema = z.object({
  id: z.number(),
  legal_business_name: z.string().min(3),
});

export type GovernanceQueryLinkerSchema = z.infer<typeof governanceQueryLinkerSchema>;
